export const calendar_item_color_options: string[] = [
  '#dbf1ff',
  '#d9defb',
  '#ffebe4',
  '#e2f1ee',
  '#fff5d9',
  '#89cff0',
  '#99c5c4',
  '#9adedb',
  '#aa9499',
  '#aaf0d1',
  '#b2fba5',
  '#b39eb5',
  '#bdb0d0',
  '#bee7a5',
  '#ca9bf7',
  '#ffb7ce',
  '#ff9899',
  '#ff694f',
  '#ff6961',
  '#fdfd96',
  '#FEE0CC',
];
